module.exports = __webpack_public_path__ + "static/media/team-leader.751c2ef7.png";